import Header from "./components/Header";
import Board from "./components/Board";
import { useDispatch, useSelector } from "react-redux";
import boardsSlice from "./redux/boardsSlice";
import EmptyBoard from "./components/EmptyBoard";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import { useEffect } from "react";
import API from "./api";
import { logout } from "./redux/authSlice";

function App() {
  const dispatch = useDispatch();
  const boards = useSelector((state) => state.boards);
  const theme = useSelector((state) => state.theme);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      const fetchBoards = async () => {
        try {
          const res = await API.get("/boards");
          dispatch(boardsSlice.actions.setBoards(res.data));
        } catch (err) {
          console.error("Failed to fetch boards", err);
          if (err.response && err.response.status === 401) {
            dispatch(logout());
          }
        }
      };
      fetchBoards();
    }
  }, [isAuthenticated, dispatch]);

  const activeBoard = boards.find((board) => board.isActive);
  if (isAuthenticated && !activeBoard && boards.length > 0)
    dispatch(boardsSlice.actions.setBoardActive({ index: 0 }));

  return (
    <div className={`app ${theme}`}>
      <Routes>
        <Route
          path="/login"
          element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/register"
          element={!isAuthenticated ? <Register /> : <Navigate to="/" />}
        />
        <Route
          path="/"
          element={
            isAuthenticated ? (
              boards.length > 0 ? (
                <>
                  <Header />
                  <Board />
                </>
              ) : (
                <>
                  <Header />
                  <EmptyBoard type="add" />
                </>
              )
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
